import api from 'service/api'

const dponetAPI = api.create('dponet')

const create = async (params) => {
  return await dponetAPI.post(`/payment_orders`, params)
}

export default { create }
